import React, { Component } from "react";
import { Button, Collapse, Alert } from "reactstrap";
import { connect } from "react-redux";
import moment from "moment";
import size from "lodash/size";
import get from "lodash/get";
import axios from "../../axios";
import * as actionCreators from "./../../modules/actions/index";
import TabBar from "../../components/TabBar/TabBar";
import Search from "../../components/Search/Search";
import DateFilter from "../../components/DateFilter/DateFilter";
import ActionsMetricsUI from "./Metrics/ActionsMetrics";
import ActionsGrid from "./DataGrid/ActionsGrid";
// import DataChartUI from './DataChart/ActionsChart';
import DataChartUI from "./DataChart/Chart";
import Loading from "../../hoc/Loading/Loading";
import * as url from "../../utils/url";
import ExportToCSV from "./ExportToCsv/ExportToCsvActions";
import { objectEncode } from "../../components/Shared/ReusablesUtils";
import PropTypes from "prop-types";
import "./Analytics.css";

const searchByUserNamePlaceholder = "Search actions...";
const Filters = "Filters";
const chartXAxesMessage =
  "Data on the chart represents weekly aggregates, starting every Monday.";
// Temporary URL for API CALL which needs to be changed when application hosted to DEV server.
// const URL = 'http://10.0.2.155:8090/charts/v1/chart-metrics/';
class ActionAnalytics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      isFilterCollapsed: false,
      searchObject: {
        metrics: [],
        // startDate: moment().subtract(1,'month').toISOString(),
        startDate:
          this.props && this.props.user && this.props.user.organizationId
            ? moment(this.props.user.organizationId.createdDate).toISOString()
            : moment().subtract(1, "month").toISOString(),
        endDate: moment().toISOString(),
        actionTitle: "",
      },
    };
  }

  componentDidMount() {
    // Fetch Chart Analytics Data
    this.fetchLatestData();
    // Fetching Users Tab Metrices
    this.props.onFetchactionsMetrices();
  }

  modifyDateTimestamp = (momentDate, date) => {
    let dateSplit = momentDate.split("T");
    return `${dateSplit[0]}${
      date === "startDate" ? "T00:00:00Z" : "T23:59:59Z"
    }`;
  };

  fetchLatestData = () => {
    // Fetch latest data with combination for filters
    const {
      searchObject: { metrics, startDate, endDate, actionTitle },
    } = this.state;
    const {
      user: { organizationId },
    } = this.props;
    const getFilterObject = {
      metrics: metrics.toString(),
      startDate: this.modifyDateTimestamp(startDate, "startDate"),
      endDate: this.modifyDateTimestamp(endDate, "endDate"),
      actionTitle: encodeURIComponent(actionTitle),
      organizationId: encodeURIComponent(organizationId._id),
    };
    axios
      .get(`${url.getActionAnalytics}${objectEncode(getFilterObject)}`)
      .then(({ data }) => {
        this.props.onFetchactionsAnalyticsSuccess(data.data.data);
      });
  };

  toggleCollapse = () => {
    const { isFilterCollapsed } = this.state;
    this.setState({
      isFilterCollapsed: !isFilterCollapsed,
    });
  };

  handleSearch = e => {
    const { value } = e.target;
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          actionTitle: value,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handleMetricsFilter = (metricId, event) => {
    const { checked } = event.target;
    let { metrics } = this.state.searchObject;

    if (checked && metrics !== undefined) {
      metrics.push(metricId);
    } else {
      metrics.splice(metrics.indexOf(metricId), 1);
    }
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          metrics,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handlePagination = e => {
    const { value } = e.target;
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          page: value,
        },
      },
      () => {
        this.fetchLatestData();
      }
    );
  };

  handleStartDateChange = date => {
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          startDate: date,
        },
      },
      () => {
        const {
          searchObject: { endDate },
        } = this.state;
        if (endDate !== "") {
          this.fetchLatestData();
        }
      }
    );
  };

  handleEndDateChange = date => {
    this.setState(
      {
        searchObject: {
          ...this.state.searchObject,
          endDate: date,
        },
      },
      () => {
        const {
          searchObject: { startDate },
        } = this.state;
        if (startDate !== "") {
          this.fetchLatestData();
        }
      }
    );
  };

  render() {
    const { isFilterCollapsed, searchObject } = this.state;
    const { actionsAnalytics, actionsMetrices, history } = this.props;
    console.log("values--", this.props);
    return (
      <div className="mt70 analytics-form">
        <div className="row ml-0 mr-0 mb-3 text-size">
          <div className="title-text">Metrics</div>
          <TabBar activeTab={"5"} history={history} />
        </div>
        <div className="row p-0 m-0 height40">
          <Search
            placeholder={searchByUserNamePlaceholder}
            handleSearch={this.handleSearch}
            value={searchObject.actionTitle}
          />
          <div className="col-lg-2 filter-select col-md-3 col-sm-3 pl0 pr0"></div>
        </div>
        {/* <DateFilter
            handleStartDateChange={this.handleStartDateChange}
            handleEndDateChange={this.handleEndDateChange}
            searchObject={searchObject}
        /> */}
        <div className="row p-0 m-0"></div>
        <div>
          <div className="dataChartStyle">
            <div className="dataChartDisplay">
              <DataChartUI
                chartValue="Actions"
                chartAnalytics={actionsAnalytics}
                chartMetrices={actionsMetrices}
                searchObject={searchObject}
              />
              <Alert className="btmMargin0" color="light">
                {chartXAxesMessage}
              </Alert>
              <p className="chartUseMsg">
                To zoom in, click and drag across the chart area. To zoom out,
                triple click on the chart area.
              </p>
            </div>
          </div>
          <div className="row">
            {actionsAnalytics.length > 0 && (
              <ExportToCSV
                Analytics={get(this.props, "actionsAnalytics", [])}
                chartMetrices={actionsMetrices}
              />
            )}
          </div>
        </div>
        <div>
          <ActionsGrid
            user={this.props.user}
            actionsAnalytics={actionsAnalytics}
            actionsMetrices={actionsMetrices}
            searchObject={searchObject}
            onFetchactionsAnalyticsSuccess={
              this.props.onFetchactionsAnalyticsSuccess
            }
          />
        </div>
      </div>
    );
  }
}

ActionAnalytics.propTypes = {
  isFilterCollapsed: PropTypes.bool,
  searchObject: PropTypes.object,
  actionsAnalytics: PropTypes.array,
  actionsMetrices: PropTypes.array,
  history: PropTypes.object,
  onFetchactionsAnalyticsSuccess: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    actionsAnalytics: state.dashboard.ActionsAnalytics,
    actionsMetrices: state.dashboard.ActionsMetrics,
    user: state.user.profile,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onFetchactionsAnalyticsSuccess: data =>
      dispatch(actionCreators.fetchActionsAnalyticsSuccess(data)),
    onFetchactionsMetrices: () =>
      dispatch(actionCreators.fetchActionsMetrices()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(ActionAnalytics, axios));
